var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "selector-body" }, [
    _c("div", { staticClass: "columns is-variable is-3" }, [
      _c("div", { staticClass: "column is-3" }, [
        _c("div", { staticClass: "repair-section" }, [
          _c("div", { staticClass: "section-title mb-2" }, [
            _vm._v("Repair Section"),
          ]),
          _c("div", { staticClass: "is-4 mb-2" }, [
            _vm._v("Quick select zones of impact"),
          ]),
          _c(
            "div",
            { staticClass: "repair-area-toggles" },
            _vm._l(_vm.defaultAreas, function (area) {
              return _c(
                "div",
                { key: area, staticClass: "repair-area-toggle mb-3" },
                [
                  _c(
                    "button",
                    {
                      class: [
                        "button",
                        "is-fullwidth",
                        "repair-toggle-btn",
                        {
                          "is-primary": _vm.isAreaSelected(area),
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.toggleRepairArea(area)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(area) +
                            " " +
                            _vm._s(
                              !area.toUpperCase().startsWith("TRIM")
                                ? "Section"
                                : ""
                            )
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "column is-5" }, [
        _c("div", { staticClass: "diagram-section" }, [
          _vm._m(0),
          _c("div", { staticClass: "vehicle-diagram pt-5" }, [
            _c("div", { staticClass: "vehicle-diagram-image" }, [
              _c(
                "svg",
                {
                  staticClass: "sedan-diagram clickable-svg",
                  attrs: {
                    version: "1.1",
                    id: "sedan-svg",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 329.8 656.1",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("FrontWindscreen"),
                      hovered: _vm.isPartHovered("FrontWindscreen"),
                    },
                    attrs: {
                      id: "FrontWindscreen",
                      "data-tippy-content": "Front Windscreen",
                      d: "M164.3,185.4c52.8,1,78.6,10.6,90.7,18l9.6-49.7c0,0-13.7-25.1-100.5-26.7c-86.8,2.3-98.8,26.1-98.8,26.1l9.5,50.1C86.3,196.2,111.4,186.8,164.3,185.4z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("FrontWindscreen")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("FrontWindscreen")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("Turret"),
                      hovered: _vm.isPartHovered("Turret"),
                    },
                    attrs: {
                      id: "Turret",
                      "data-tippy-content": "Turret",
                      d: "M254.1,208.1c-12.4-7.4-38.1-16.6-89.9-17.6c-51.2,1.3-76.4,10.2-88.4,17.2c2.8,23,23.8,199.2,11.6,282.4c13.4,5,38.7,11.6,78.8,12.3c40.2-1,65.4-7.9,78.7-12.9C231.6,403.6,250.3,244.9,254.1,208.1z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("Turret")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("Turret")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RightCantRail"),
                      hovered: _vm.isPartHovered("RightCantRail"),
                    },
                    attrs: {
                      id: "RightCantRail",
                      "data-tippy-content": "Right Cant Rail",
                      d: "M249.9,488c-5-35.1-4.9-83.1-3.7-129.3c0.1-2.7,2.1-121.7,22.6-204.5l9.9-7.3c-15.2,47-21.1,206.9-21.3,209.6c-1.2,46.2-0.3,92,4.7,127.1",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RightCantRail")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RightCantRail")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("LeftCantRail"),
                      hovered: _vm.isPartHovered("LeftCantRail"),
                    },
                    attrs: {
                      id: "LeftCantRail",
                      "data-tippy-content": "Left Cant Rail",
                      d: "M82.7,488.6c4.7-35.2,4.2-83.2,2.6-129.4c-0.2-2.7-3.1-121.6-24.3-204.3l-10-7.2c15.6,46.9,22.8,206.7,23,209.4c1.6,46.2,1,92-3.7,127.1",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("LeftCantRail")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("LeftCantRail")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("LeftFrontDoor"),
                      hovered: _vm.isPartHovered("LeftFrontDoor"),
                    },
                    attrs: {
                      id: "LeftFrontDoor",
                      "data-tippy-content": "Left Front Door",
                      d: "M0,192c0.4-6.9,3.1-13.5,7.6-18.7c5-5.9,14.8-7.8,21-8.3c-0.5-25.3-1.2-32.6-1.2-32.6l18.7,13.4c0,0,17.4,89.6,18.7,176.1h-1.9L31.6,322l-1.8-102.5c-0.3-13.2-0.5-24.7-0.7-35.3C15.4,190,0,192,0,192z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("LeftFrontDoor")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("LeftFrontDoor")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RightFrontDoor"),
                      hovered: _vm.isPartHovered("RightFrontDoor"),
                    },
                    attrs: {
                      id: "RightFrontDoor",
                      "data-tippy-content": "Right Front Door",
                      d: "M329.8,190.7c-0.5-6.9-3.2-13.5-7.7-18.7c-5.1-5.9-14.9-7.6-21-8.2c0.3-25.3,0.9-32.6,0.9-32.6l-18.6,13.6c0,0-16.7,89.7-17.2,176.2h1.9l31.3-0.1l1-102.5c0.2-13.2,0.3-24.7,0.4-35.3C314.4,188.8,329.8,190.7,329.8,190.7z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RightFrontDoor")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RightFrontDoor")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("LeftRearDoor"),
                      hovered: _vm.isPartHovered("LeftRearDoor"),
                    },
                    attrs: {
                      id: "LeftRearDoor",
                      "data-tippy-content": "Left Rear Door",
                      d: "M64.2,326.6c0,0,2.8,54,2,79.7c0,0.3,0,0.5,0,0.7c-0.3,30.1-3.1,56.5-4.6,75.6l-17.9-6.5c-4.8-22.2-9.1-49.9-10.2-77.3c-0.8-18.4-1.5-44.3-2.3-72.1L64.2,326.6z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("LeftRearDoor")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("LeftRearDoor")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RightRearDoor"),
                      hovered: _vm.isPartHovered("RightRearDoor"),
                    },
                    attrs: {
                      id: "RightRearDoor",
                      "data-tippy-content": "Right Rear Door",
                      d: "M265.6,325.8c0,0-2.4,54.1-1.3,79.7c0,0.3,0,0.5,0,0.7c0.5,30.1,3.6,56.5,5.2,75.6l17.9-6.7c4.6-22.2,8.7-50,9.6-77.4c0.6-18.4,1.2-44.3,1.7-72.1L265.6,325.8z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RightRearDoor")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RightRearDoor")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("FrontBumper"),
                      hovered: _vm.isPartHovered("FrontBumper"),
                    },
                    attrs: {
                      id: "FrontBumper",
                      "data-tippy-content": "Front Bumper",
                      d: "M236.2,27.2c-4.1-8.8-7.2-15.1-8.7-17.2c-6.4-9-61.4-10-61.4-10h-0.3c0,0-55,1-61.4,10c-1.5,2.1-4.8,8.6-8.9,17.8C132.2,23.7,179.8,19.8,236.2,27.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("FrontBumper")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("FrontBumper")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RightFrontLamps"),
                      hovered: _vm.isPartHovered("RightFrontLamps"),
                    },
                    attrs: {
                      id: "RightFrontLamps",
                      "data-tippy-content": "Right Front Lamps",
                      d: "M269.7,32.2c-13.4-15.7-16.1-17.8-38.3-23.6c4.4,7.2,6.6,12.1,10,19.2C252.4,28.8,260.6,30.6,269.7,32.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RightFrontLamps")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RightFrontLamps")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("LeftFrontLamps"),
                      hovered: _vm.isPartHovered("LeftFrontLamps"),
                    },
                    attrs: {
                      id: "LeftFrontLamps",
                      "data-tippy-content": "Left Front Lamps",
                      d: "M60.1,32.2C73.5,16.5,76.2,14.4,98.4,8.6c-4.4,7.2-6.6,12.1-10,19.2C77.4,28.8,69.2,30.6,60.1,32.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("LeftFrontLamps")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("LeftFrontLamps")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RightFrontGuard"),
                      hovered: _vm.isPartHovered("RightFrontGuard"),
                    },
                    attrs: {
                      id: "RightFrontGuard",
                      "data-tippy-content": "Right Front Guard",
                      d: "M288.8,71.2c-1.9-6.2-4.7-12.8-8.4-19.4c-2.8-5.2-6-10.1-9.7-14.6l-0.1-0.1c-9.5-2.1-19.2-3.6-28.9-4.5c8.8,17.2,19.1,43.1,27.2,67c5,13.5,9.6,26.9,13,38.8l17.1-11.6C299,126.8,298.5,99.2,288.8,71.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RightFrontGuard")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RightFrontGuard")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("LeftFrontGuard"),
                      hovered: _vm.isPartHovered("LeftFrontGuard"),
                    },
                    attrs: {
                      id: "LeftFrontGuard",
                      "data-tippy-content": "Left Front Guard",
                      d: "M41,71.2c1.9-6.2,4.7-12.8,8.4-19.4c2.8-5.2,6-10.1,9.7-14.6l0.1-0.1c9.5-2.1,19.2-3.6,28.9-4.5c-8.8,17.2-19.1,43.1-27.2,67c-5,13.5-9.6,26.9-13,38.8l-17.1-11.6C30.8,126.8,31.3,99.2,41,71.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("LeftFrontGuard")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("LeftFrontGuard")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("Bonnet"),
                      hovered: _vm.isPartHovered("Bonnet"),
                    },
                    attrs: {
                      id: "Bonnet",
                      "data-tippy-content": "Bonnet",
                      d: "M267.8,146.2l7.7-5.3C272,116,248.6,60,235.1,31.5C178.7,24.3,131,28,94.4,32.1C80.8,61,57.5,117,54.2,141.5l7.5,5.2c2.1-2.8,20.1-22.6,103.2-24.2C245,123.9,264.6,142.4,267.8,146.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("Bonnet")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("Bonnet")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("LeftQuarterPanel"),
                      hovered: _vm.isPartHovered("LeftQuarterPanel"),
                    },
                    attrs: {
                      id: "LeftQuarterPanel",
                      "data-tippy-content": "Left Quarter Panel",
                      d: "M43.2,481.2l18.4,6.3c0,0-3.5,34.1,11.8,132c0,0-12.9-6-17.2-12.3C56,607.3,32.4,531.3,43.2,481.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("LeftQuarterPanel")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("LeftQuarterPanel")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RightQuarterPanel"),
                      hovered: _vm.isPartHovered("RightQuarterPanel"),
                    },
                    attrs: {
                      id: "RightQuarterPanel",
                      "data-tippy-content": "Right Quarter Panel",
                      d: "M286.6,481.2l-18.4,6.3c0,0,3.5,34.1-11.8,132c0,0,12.9-6,17.2-12.3C273.8,607.3,297.4,531.3,286.6,481.2z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RightQuarterPanel")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RightQuarterPanel")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RearBumper"),
                      hovered: _vm.isPartHovered("RearBumper"),
                    },
                    attrs: {
                      id: "RearBumper",
                      "data-tippy-content": "Rear Bumper",
                      d: "M165.2,632.8c-43.2,0.3-72.3-3.2-88.2-5.8c1.4,7.5,3.4,15.3,5.8,19.4c0,0,39.7,10.1,81.9,9.7h0.3c42.2,0.4,81.8-9.7,81.8-9.7c2.5-4.2,4.4-12.3,5.9-20C236.8,629.1,207.9,632.8,165.2,632.8z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RearBumper")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RearBumper")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RearWindscreen"),
                      hovered: _vm.isPartHovered("RearWindscreen"),
                    },
                    attrs: {
                      id: "RearWindscreen",
                      "data-tippy-content": "Rear Windscreen",
                      d: "M164.5,552.2c-44.3,0.5-91.7-12.9-91.7-12.9c-5.8-12.6-3.4-51-3.4-51s30.9,18.2,95.3,17.7c64.4,0.5,95.3-17.7,95.3-17.7s3.4,38.4-2.5,51c0,0-48.3,13.4-92.6,12.9",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RearWindscreen")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RearWindscreen")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("Bootlid"),
                      hovered: _vm.isPartHovered("Bootlid"),
                    },
                    attrs: {
                      id: "Bootlid",
                      "data-tippy-content": "Bootlid",
                      d: "M164.9,556.3h-0.3c-40.8,0.4-84-10.5-93.1-12.9c0.6,10.4,3.3,55.1,7.7,77.6c9.3,2.1,37.6,7.3,86.2,7c48.2,0,76.4-5.4,85.9-7.6c4.1-21.9,6.4-64.7,7-76.7C247.7,546.4,204.8,556.8,164.9,556.3z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("Bootlid")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("Bootlid")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("RightRearLamps"),
                      hovered: _vm.isPartHovered("RightRearLamps"),
                    },
                    attrs: {
                      id: "RightRearLamps",
                      "data-tippy-content": "Right Rear Lamps",
                      d: "M257.1,625.8c-1.4,7.6-3.3,15.5-5.7,20.1c3.6-1.6,10.7-5,13.4-7.7c3.6-3.8,8.3-23,8.3-23S267,620.2,257.1,625.8z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("RightRearLamps")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("RightRearLamps")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                  _c("path", {
                    staticClass: "has-tooltip",
                    class: {
                      selected: _vm.isPartSelected("LeftRearLamps"),
                      hovered: _vm.isPartHovered("LeftRearLamps"),
                    },
                    attrs: {
                      id: "LeftRearLamps",
                      "data-tippy-content": "Left Rear Lamps",
                      d: "M72.7,625.8c1.4,7.6,3.3,15.5,5.7,20.1c-3.6-1.6-10.7-5-13.4-7.7c-3.6-3.8-8.3-23-8.3-23S62.8,620.2,72.7,625.8z",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectPartBySection("LeftRearLamps")
                      },
                      mouseenter: function ($event) {
                        return _vm.onPathMouseEnter("LeftRearLamps")
                      },
                      mouseleave: _vm.onPathMouseLeave,
                    },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "column is-4" }, [
        _c("div", { staticClass: "groups-section" }, [
          _c(
            "div",
            {
              staticClass:
                "section-title is-6 mb-2 is-flex is-justify-content-space-between",
            },
            [
              _c("span", [_vm._v("Selected Areas")]),
              _vm.selectedItems.length > 0
                ? _c(
                    "span",
                    {
                      staticClass:
                        "tag is-primary is-size-6 is-rounded has-text-white",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedItemsSelectedCount) +
                          " / " +
                          _vm._s(_vm.selectedItemsCount) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "groups-selection" }, [
            _vm.selectedAreasParts.length > 0
              ? _c(
                  "div",
                  { staticClass: "selected-groups" },
                  _vm._l(_vm.selectedAreasParts, function (group) {
                    return _c(
                      "div",
                      {
                        key: group.name,
                        ref: `group-${group.name}`,
                        refInFor: true,
                        staticClass: "group-block",
                      },
                      [
                        _c("div", { staticClass: "group-title" }, [
                          _c("span", { staticClass: "group-name" }, [
                            _vm._v(_vm._s(group.name)),
                          ]),
                          _c("div", { staticClass: "group-actions ml-auto" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-small is-text",
                                attrs: {
                                  disabled:
                                    _vm.areAllPartsSelectedInGroup(group),
                                  title: "Select All",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectAllInGroup(group)
                                  },
                                },
                              },
                              [_vm._m(1, true)]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "button is-small is-text",
                                attrs: {
                                  disabled:
                                    _vm.areNoPartsSelectedInGroup(group),
                                  title: "Select None",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectNoneInGroup(group)
                                  },
                                },
                              },
                              [_vm._m(2, true)]
                            ),
                          ]),
                        ]),
                        _c(
                          "draggable",
                          {
                            staticClass: "draggable-parts",
                            attrs: {
                              options: {
                                animation: 150,
                                ghostClass: "ghost-part",
                                chosenClass: "chosen-part",
                                handle: ".part-handle",
                                containment: "parent",
                                preventOnFilter: false,
                                forceFallback: true,
                                fallbackClass: "fallback-part",
                                disabled: !_vm.sortable,
                              },
                            },
                            on: {
                              start: _vm.onPartDragStart,
                              move: _vm.onPartDragMove,
                              end: function ($event) {
                                return _vm.onPartDragEnd(group)
                              },
                            },
                            model: {
                              value: group.items,
                              callback: function ($$v) {
                                _vm.$set(group, "items", $$v)
                              },
                              expression: "group.items",
                            },
                          },
                          _vm._l(group.items, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.partid,
                                staticClass:
                                  "group-item is-flex is-justify-content-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "is-flex is-align-items-center",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.checked,
                                              expression: "item.checked",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(item.checked)
                                              ? _vm._i(item.checked, null) > -1
                                              : item.checked,
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$a = item.checked,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        item,
                                                        "checked",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        item,
                                                        "checked",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(item, "checked", $$c)
                                                }
                                              },
                                              _vm.updateSelectedItems,
                                            ],
                                          },
                                        }),
                                        _c("div", { staticClass: "state" }, [
                                          _c("i", {
                                            staticClass: "icon mdi mdi-check",
                                          }),
                                          _c("label"),
                                        ]),
                                      ]
                                    ),
                                    _c("span", { staticClass: "ml-2" }, [
                                      _vm._v(_vm._s(item.partname)),
                                    ]),
                                  ]
                                ),
                                _vm.sortable
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mso mso-16px part-handle is-flex is-align-items-flex-end",
                                      },
                                      [_vm._v("swap_vert")]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c("section", { staticClass: "section" }, [_vm._m(3)]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "is-flex is-align-items-center diagram-container" },
      [
        _c(
          "div",
          {
            staticClass: "section-title mb-2",
            staticStyle: { flex: "1", "text-align": "center" },
          },
          [_vm._v("Butterfly")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "content has-text-grey has-text-centered" },
      [
        _c("span", { attrs: { icon: "icon is-large" } }, [
          _c("i", { staticClass: "mdi mdi-48px mdi-car-off" }),
        ]),
        _c("p", [_vm._v("There are no items in your list.")]),
        _c("p", [
          _vm._v(
            "Start by selecting zones of impacts or areas from the vehicle butterfly."
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }